import * as React from "react";
import TableFilterDropdown from "../../../react-core/Html/Components/TableFilterDropdown";
import { AdviserSiteTagManagerEvent } from "../Cookies/ChoicesCookie/AdviserSiteTagManager";
import { ITableConfig } from "../Table/Table";
import { TableColFilter } from "./TableColFilter";

export interface ITableColEditorProps {
    tableEditorKey: string;
    col: ITableConfig[];
    header?: Array<string>;
    disableDrag?: boolean;
    title?: string;
    event?: AdviserSiteTagManagerEvent;
}

export const TableColEditor = (props: ITableColEditorProps) => {
    const tableEditorRef = React.useRef(null);

    return (
        <TableFilterDropdown
            title={props.title}
            labelSrOnly="Open the table editor dropdown"
            cssWrapper={"table-column-filter"}
            ref={tableEditorRef}
            event={props.event}
        >
            <TableColFilter
                onApply={() => tableEditorRef.current.close()}
                onCancel={() => tableEditorRef.current.close()}
                tableKey={props.tableEditorKey}
                col={props.col}
                disableDrag={props.disableDrag}
            />
        </TableFilterDropdown>
    );
};
